// extracted by mini-css-extract-plugin
module.exports = {"component":"modal_component__3xGLM"};